import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { findLinkBy } from '../../../../../Fetch';
import { T } from '../../../../../Translations';
import Button from '../../../../Form/Button';
import { useOpenable } from '../../../Modal/UseOpenable';
import AddParticipantsToGroupModal from '../../AddParticipantsToGroupModal';
import { ImportedParticipantsResource } from '../../Store/Types';

interface Props {
  successfulParticipantsResource: ImportedParticipantsResource;
}

const AddToGroup: React.FC<Props> = ({ successfulParticipantsResource }) => {
  const { open, close, modalState } = useOpenable();
  return findLinkBy({ rel: 'create' }, successfulParticipantsResource.links)
    .map(() => (
      <>
        <div className="mt-4 text-sm font-semibold">
          <T kind="What would you like to do next?" />
        </div>
        <Button
          className={clsx(
            'rounded-md cursor-pointer bg-teal-600 text-white px-6 py-4 my-4 text-sm',
            'text-center mx-auto',
          )}
          value="Add to group"
          type="button"
          onClick={open}
        />
        <AddParticipantsToGroupModal
          close={close}
          modalState={modalState}
          successfulParticipantsResource={successfulParticipantsResource}
        />

        <div
          className="text-teal-600 mb-4"
          data-test-close-button="true"
          aria-label="Close"
          role="button"
        ></div>
      </>
    ))
    .getOrElse(emptyFragment);
};

export default observer(AddToGroup);
